import React, { useState } from "react";
import "./styles.scss";
import "react-datepicker/dist/react-datepicker.css";
import MusicGenres from "../../shared/MusicGenres";
import Input from "../UploadComponents/Input";
import RadioButtons from "../UploadComponents/RadioButtons";
import MediaSelector from "../UploadComponents/MediaSelector";
import PostToNewsfeedToggle from "../UploadComponents/PostToNewsfeedToggle";
import PreviewImage from "../UploadComponents/PreviewImage";
import FeatureArtist from "../UploadComponents/FeatureArtist";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ProgressBar, Spinner } from "react-bootstrap";
import { isWithinSoundtrackSizeLimit } from "../../../shared/viewsHelper";
import { createMedium, draggableMediaTypes } from "../../../../api/media";
import { uploadMedia } from "../../../../api/aws_s3";
import { object_url } from "../../../../api/helper";
import { useHistory } from "react-router-dom";
import PrimoSubscriptionModal from "../../shared/PrimoSubscriptionModal";
import { useLocation } from "react-router-dom";
import DatePicker from "../UploadComponents/DatePicker";


function Single() {
  const current_user = useSelector(({ current_user }: any) => current_user);
  const [progress, setProgress] = useState(-1);
  const history = useHistory();
  const [subscribeModal, setSubscribeModal] = useState(false);
  const [newErrors, setNewErrors] = useState({});
  const { hash } = useLocation();
  const {
    handleSubmit,
    handleChange,
    setFieldError,
    values,
    isSubmitting,
    isValid,
    errors,
  } = useFormik({
    initialValues: {
      title: "",
      label: "",
      download_link: "",
      preview_image: null as any,
      file: null as any,
      featured_artists: [],
      is_mastered: true,
      lyrics: "clean",
      description: "",
      tags: null,
      post_on_create: false,
      release_date: new Date(),
      is_single: true,
      is_track_type: "single_track"
      // single_track_distribute: true
    },
    validationSchema: Yup.object({
      title: Yup.string().trim(),
      label: Yup.string(),
      download_link: Yup.string().url(),
      featured_artists: Yup.array().of(Yup.string()).nullable(),
      tags: Yup.array().of(Yup.string()).nullable(),
      lyrics: Yup.string().oneOf(["clean", "explicit"]),
      description: Yup.string(),
      is_mastered: Yup.boolean(),
      post_on_create: Yup.boolean(),
      release_date: Yup.date().nullable(),
      is_single: Yup.boolean(),
      is_track_type: Yup.string()
      // single_track_distribute: Yup.boolean()
    }),
    onSubmit: async (values) => {
      try {
        let isError = false
        if (values.title.length == 0) {
          isError = true
          setNewErrors({title: 'Title is required'});
        }

        if (values.file == null) {
          isError = true
          setNewErrors({file: 'Please pick a file'});
        }

        if (values.file != null && !isWithinSoundtrackSizeLimit(values.file)) {
          isError = true
          setNewErrors({file: 'Oops! Your file size is too large. Try uploading a smaller version that is 300MB or less.'});
        }

        if (values.file != null && !draggableMediaTypes.includes(values.file.type)) {
          isError = true
          setNewErrors({file: 'Unsupported File Format'});
        }


        if (!isError) {
          const s3_object_key = object_url();
          await uploadMedia(
            values.file,
            values.file.type,
            current_user.id,
            s3_object_key,
            (e: any) => setProgress((e.loaded * 100) / e.total)
          );

          await createMedium({
            media: {
              type: "SoundTrack",
              s3_object_key,
              title: values.title,
              label: values.label,
              download_link: values.download_link,
              description: values.description,
              preview_image_id: values.preview_image?.id,
              featured_artists: values.featured_artists,
              is_mastered: values.is_mastered,
              lyrics: values.lyrics,
              tags: values.tags,
              post_on_create: values.post_on_create,
              release_date: values.release_date,
              is_single: values.is_single,
              is_track_type: values.is_track_type
            },
          });
          history.push(`/upload/done`);

        }
      } catch (err) {

        setFieldError(
          "general",
          err.response.data.errors?.map((error: any) => error.message)
        );
      }
    },
  });

  const setValue = (name: any) => (value: any) => {
    return handleChange({ target: { name, value } });
  };

  const handleDistributeClick = () => {
    if (current_user.is_subscribed_to_primo) {
      window.open(process.env.REACT_APP_EVEARA_BASE_URL);
    } else {
      setSubscribeModal(true);
    }
  };

  console.log(newErrors);
  return (
    <div
      id="upload-single"
      className="flex-grow-1 d-flex flex-column justify-content-between m-4"
    >
      <h1>Upload a Single</h1>
      <div className="d-block">
        <div className="d-xl-flex mt-4">
          <PreviewImage
            previewImage={values.preview_image}
            onChange={setValue("preview_image")}
            checkCoverSizeValidation
          />
          <div className="flex-grow-1 mx-3">
            <Input
              placeholder="Title"
              label="Title"
              type="text"
              name="title"
              value={values.title}
              onChange={handleChange}
              required
            />
            <Input
              placeholder="By"
              label="By"
              type="text"
              disabled
              value={current_user.username}
            />
            <Input
              placeholder="Label"
              label="Label"
              type="text"
              value={values.label}
              name="label"
              onChange={handleChange}
            />
            <FeatureArtist
              onAddNewArtist={setValue("featured_artists")}
              feature={values.featured_artists}
            />
          </div>
        </div>
      </div>

      <div className="d-flex text-dark bold mt-4 mb-5">
        <label className="mr-3">Choose a track:</label>
        {values.file && <p>{values.file?.name}</p>}
        <MediaSelector
          onChange={(event: any) => {
            setValue("file")(event.currentTarget.files[0]);
          }}
          name="file"
          label={values.file ? "re-upload" : "upload"}
        />
        <input name="is_track_type" value="single_track" type="hidden" />
      </div>
      <div className="d-flex file_note">
        <p><b>Accepted Formats:</b> .mp3, .m4a*, .wav, .flac, .ogg or .aiff*<br/>
          <span>
            <b>*Please note:</b> m4a and aiff formats are accepted for use in music distribution purposes<b> only</b> (via UNIFI Music's <a href='javascript:void(0)' onClick={handleDistributeClick}>PRIMO plan</a>), but will not play on any on-site players, or our embeddable music player due to compatibility issues with browser-based audio players.
          </span>
        </p>
      </div>

      <RadioButtons
        options={[
          { label: "Yes", value: true },
          { label: "No", value: false },
        ]}
        label="Is this Mastered?"
        name="is_mastered"
        selected={values.is_mastered}
        onChange={handleChange}
      />

      <RadioButtons
        options={[
          { label: "clean", value: "clean" },
          { label: "explicit", value: "explicit" },
        ]}
        label="Lyrics:"
        name="lyrics"
        selected={values.lyrics}
        onChange={handleChange}
      />

      <Input
        placeholder="Download link"
        label="Download Link"
        type="text"
        lablePosition="top"
        name="download_link"
        value={values.download_link}
        onChange={handleChange}
      />

      <Input
        lablePosition="top"
        placeholder="description"
        label="Description"
        type="textarea"
        name="description"
        value={values.description}
        onChange={handleChange}
      />
      {/*<input
        name="single_track_distribute"
        value="true"
        type="hidden"
      />*/}
      <input
        name="is_single"
        value="true"
        type="hidden"
      />
      <div className="genres mb-5">
        <label> Genre(s):</label>
        <MusicGenres defaultChecked={[]} onChange={setValue("tags")} />
      </div>
      <PostToNewsfeedToggle
        onChange={setValue("post_on_create")}
        value={values.post_on_create}
      />
      <DatePicker
        onChange={setValue("release_date")}
        selected={values.release_date}
      />
      {Object.keys(newErrors).length ? (
        <div className="alert alert-danger">
          {Object.keys(newErrors)
            // @ts-ignore
            .map((key: string) => newErrors[key])
            .join(", ")}
        </div>
      ) : null}
      <div className="py-5">
        <div className="d-flex flex-column align-items-center">
          {progress > -1 && (
            <ProgressBar
              now={progress}
              label={
                progress === 100
                  ? "Processing"
                  : `${Math.round(progress)}% UPLOADED`
              }
            />
          )}
          <button
            // @ts-ignore
            onClick={handleSubmit}
            disabled={!isValid || isSubmitting}
            className={`btn btn-primary btn-md ${
              !isValid || isSubmitting ? "disabled" : ""
            }`}
          >
            {isSubmitting && (
              <Spinner animation={"border"} size={"sm"} className="mr-3" />
            )}
            Upload
          </button>
        </div>
      </div>
      {(subscribeModal || ["#primo", "#primo-info"].includes(hash)) && (
        <PrimoSubscriptionModal
          showModal={subscribeModal}
          setSubscribeModal={setSubscribeModal}
          hash={["#primo", "#primo-info"].includes(hash)}
          showDistributingInfo={hash === "#primo-info"}
        />
      )}
    </div>
  );
}

export default Single;
